// extracted by mini-css-extract-plugin
export var title = "layout-module--title--1ZPyO";
export var separator = "layout-module--separator--T0eeE";